import NewsArticlePage from './newsArticlePage';

export default NewsArticlePage;
